import { FormatNumberWithCommas } from "../../../../shared/scripts/number-functions";
import { AggregatedParticipants } from "./enrollment.entities";



export class ProgressBarSection {

    constructor() { }

    updateProgressBarData(aggregatedParticipants: AggregatedParticipants): void {

        this.updateRecoverCohortData(aggregatedParticipants.RecoverCohort, aggregatedParticipants.Count);
        this.updateRaceData(aggregatedParticipants.Race, aggregatedParticipants.Count);
        this.updateHispanicData(aggregatedParticipants.Hispanic, aggregatedParticipants.Count);
        this.updateNonWhiteHispanicData(aggregatedParticipants.NonWhiteHispanic, aggregatedParticipants.Count);
        this.updateSexData(aggregatedParticipants.Sex, aggregatedParticipants.Count);
        this.updateAgeData(aggregatedParticipants.Age, aggregatedParticipants.Count);
        //this.updateSymptomClusterExIntData(aggregatedParticipants.ClusterExInt, aggregatedParticipants.Count);
        //this.updateSymptomClusterCogDysData(aggregatedParticipants.ClusterCogn, aggregatedParticipants.Count);
        //this.updateSymptomClusterAutonomicData(aggregatedParticipants.ClusterAuto, aggregatedParticipants.Count);
    }

    private setProgressBarValue(label: string, valueElementId: string, labelElementId: string, percent: number, count: number): void {
        //both title attributes need to be updated for tooltip to refresh
        let tooltipText: string = label + " (" + Math.round(percent) + "%; n=" + FormatNumberWithCommas(String(count)) + ")";
        $(valueElementId).css('width', percent + '%').attr('aria-valuenow', percent).attr('data-title', tooltipText).attr('data-original-title', tooltipText);
        $(labelElementId).css('width', percent + '%').attr('aria-valuenow', percent);
        $(valueElementId).tooltip();

        if ((label == "Unknown" && percent < 12) || (label != "Unknown" && percent < 10)) {
            //$(labelElementId).addClass('hide');
            $(labelElementId).text("");
            $(valueElementId).text("");

        }
        else {
            $(labelElementId).text(label);
            //$(labelElementId).removeClass('hide');
            $(valueElementId).text(Math.round(percent) + "%");
        }
    }

    private updateRecoverCohortData(data: number[], totalCount: number): void {

        if (totalCount == 0) { this.hideProgressBar('progressbar-recovercohort'); $('#progressbar-message-recovercohort').show(); return; }
        else { $('#progressbar-message-recovercohort').hide(); this.showProgressBar('progressbar-recovercohort'); }

        this.setProgressBarValue('Yes', '#value-recovercohort-yes', '#label-recovercohort-yes', ((data[1] / totalCount) * 100), data[1]);
        this.setProgressBarValue('No', '#value-recovercohort-no', '#label-recovercohort-no', ((data[0] / totalCount) * 100), data[0]);
        this.setProgressBarValue('Unknown', '#value-recovercohort-unknown', '#label-recovercohort-unknown', ((data[2] / totalCount) * 100), data[2]);
    }

    private updateRaceData(data: number[], totalCount: number): void {
        if (totalCount == 0) { this.hideProgressBar('progressbar-race'); $('#progressbar-message-race').show(); return; }
        else { $('#progressbar-message-race').hide(); this.showProgressBar('progressbar-race'); }

        this.setProgressBarValue('AIAN', '#value-race-aian', '#label-race-aian', (data[1] / totalCount) * 100, data[1]);
        this.setProgressBarValue('Asian', '#value-race-asian', '#label-race-asian', (data[2] / totalCount) * 100, data[2]);
        this.setProgressBarValue('Black', '#value-race-black', '#label-race-black', (data[3] / totalCount) * 100, data[3]);
        this.setProgressBarValue('MENA', '#value-race-mena', '#label-race-mena', (data[4] / totalCount) * 100, data[4]);
        this.setProgressBarValue('NHPI', '#value-race-nhpi', '#label-race-nhpi', (data[5] / totalCount) * 100, data[5]);
        this.setProgressBarValue('White', '#value-race-white', '#label-race-white', (data[6] / totalCount) * 100, data[6]);
        this.setProgressBarValue('Multiple', '#value-race-multiple', '#label-race-multiple', (data[0] / totalCount) * 100, data[0]);
        this.setProgressBarValue('Unknown', '#value-race-unknown', '#label-race-unknown', (data[7] / totalCount) * 100, data[7]);
    }

    private updateHispanicData(data: number[], totalCount: number): void {

        if (totalCount == 0) { this.hideProgressBar('progressbar-hispanic'); $('#progressbar-message-hispanic').show(); return; }
        else { $('#progressbar-message-hispanic').hide(); this.showProgressBar('progressbar-hispanic'); }

        this.setProgressBarValue('Hispanic', '#value-hispanic-yes', '#label-hispanic-yes', ((data[1] / totalCount) * 100), data[1]);
        this.setProgressBarValue('Not Hispanic', '#value-hispanic-no', '#label-hispanic-no', ((data[0] / totalCount) * 100), data[0]);
        this.setProgressBarValue('Unknown', '#value-hispanic-unknown', '#label-hispanic-unknown', ((data[2] / totalCount) * 100), data[2]);
    }

    private updateNonWhiteHispanicData(data: number[], totalCount: number): void {

        if (totalCount == 0) { this.hideProgressBar('progressbar-nonwhitehispanic'); $('#progressbar-message-nonwhitehispanic').show(); return; }
        else { $('#progressbar-message-nonwhitehispanic').hide(); this.showProgressBar('progressbar-nonwhitehispanic'); }

        this.setProgressBarValue('Yes', '#value-nonwhitehispanic-yes', '#label-nonwhitehispanic-yes', ((data[1] / totalCount) * 100), data[1]);
        this.setProgressBarValue('No', '#value-nonwhitehispanic-no', '#label-nonwhitehispanic-no', ((data[0] / totalCount) * 100), data[0]);
        this.setProgressBarValue('Unknown', '#value-nonwhitehispanic-unknown', '#label-nonwhitehispanic-unknown', ((data[2] / totalCount) * 100), data[2]);
    }

    private updateSexData(data: number[], totalCount: number): void {
        if (totalCount == 0) { this.hideProgressBar('progressbar-sex'); $('#progressbar-message-sex').show(); return; }
        else { this.showProgressBar('progressbar-sex'); $('#progressbar-message-sex').hide(); }

        this.setProgressBarValue('Female', '#value-sex-female', '#label-sex-female', ((data[0] / totalCount) * 100), data[0]);
        this.setProgressBarValue('Male', '#value-sex-male', '#label-sex-male', ((data[1] / totalCount) * 100), data[1]);
        this.setProgressBarValue('Intersex', '#value-sex-intersex', '#label-sex-intersex', ((data[2] / totalCount) * 100), data[2]);
        this.setProgressBarValue('Prefer Not To Answer', '#value-sex-notanswered', '#label-sex-notanswered', ((data[3] / totalCount) * 100), data[3]);
        this.setProgressBarValue('Unknown', '#value-sex-unknown', '#label-sex-unknown', ((data[4] / totalCount) * 100), data[4]);
    }

    private updateAgeData(data: number[], totalCount: number): void {
        if (totalCount == 0) { this.hideProgressBar('progressbar-age'); $('#progressbar-message-age').show(); return; }
        else { $('#progressbar-message-age').hide(); this.showProgressBar('progressbar-age'); }

        this.setProgressBarValue('18-45', '#value-age-18_45', '#label-age-18_45', (data[0] / totalCount) * 100, data[0]);
        this.setProgressBarValue('46-65', '#value-age-46_65', '#label-age-46_65', (data[1] / totalCount) * 100, data[1]);
        //this.setProgressBarValue('51-70', '#value-age-51_70', '#label-age-51_70', (data[2] / totalCount) * 100, data[2]);
        this.setProgressBarValue('>65', '#value-age-more65', '#label-age-more65', (data[2] / totalCount) * 100, data[2]);
        this.setProgressBarValue('Unknown', '#value-age-unknown', '#label-age-unknown', (data[3] / totalCount) * 100, data[3]);
    }

    //private updateSymptomClusterExIntData(data: number[], totalCount: number): void {

    //    if (totalCount == 0) { this.hideProgressBar('progressbar-exint'); $('#progressbar-message-exint').show(); return; }
    //    else { $('#progressbar-message-exint').hide(); this.showProgressBar('progressbar-exint'); }

    //    this.setProgressBarValue('Yes', '#value-exint-yes', '#label-exint-yes', ((data[1] / totalCount) * 100), data[1]);
    //    this.setProgressBarValue('No', '#value-exint-no', '#label-exint-no', ((data[0] / totalCount) * 100), data[0]);
    //    this.setProgressBarValue('Unknown', '#value-exint-unknown', '#label-exint-unknown', ((data[2] / totalCount) * 100), data[2]);
    //}

    //private updateSymptomClusterCogDysData(data: number[], totalCount: number): void {

    //    if (totalCount == 0) { this.hideProgressBar('progressbar-cogdys'); $('#progressbar-message-cogdys').show(); return; }
    //    else { $('#progressbar-message-cogdys').hide(); this.showProgressBar('progressbar-cogdys'); }

    //    this.setProgressBarValue('Yes', '#value-cogdys-yes', '#label-cogdys-yes', ((data[1] / totalCount) * 100), data[1]);
    //    this.setProgressBarValue('No', '#value-cogdys-no', '#label-cogdys-no', ((data[0] / totalCount) * 100), data[0]);
    //    this.setProgressBarValue('Unknown', '#value-cogdys-unknown', '#label-cogdys-unknown', ((data[2] / totalCount) * 100), data[2]);
    //}

    //private updateSymptomClusterAutonomicData(data: number[], totalCount: number): void {

    //    if (totalCount == 0) { this.hideProgressBar('progressbar-autonomic'); $('#progressbar-message-autonomic').show(); return; }
    //    else { $('#progressbar-message-autonomic').hide(); this.showProgressBar('progressbar-autonomic'); }

    //    this.setProgressBarValue('Yes', '#value-autonomic-yes', '#label-autonomic-yes', ((data[1] / totalCount) * 100), data[1]);
    //    this.setProgressBarValue('No', '#value-autonomic-no', '#label-autonomic-no', ((data[0] / totalCount) * 100), data[0]);
    //    this.setProgressBarValue('Unknown', '#value-autonomic-unknown', '#label-autonomic-unknown', ((data[2] / totalCount) * 100), data[2]);
    //}

    private hideProgressBar(id: string): void {
        $('#' + id).removeClass('d-flex');
        $('#' + id).addClass('d-none');

    }
    private showProgressBar(id: string): void {
        $('#' + id).removeClass('d-none');
        $('#' + id).addClass('d-flex');
    }
}

